<template>
	<div id="page_5">
		<h1>
			<img src="../../assets/img/home/logo_2.png" />
			<div>物联网控制APP</div>
			<div>智能生活·一手掌握</div>
		</h1>
		<div class="btn-group">
			<el-popover placement="bottom" trigger="hover"><img src='../../assets/img/home/code_ios.png'>
				<el-button slot="reference">
					<i class="iconfont icon-ios"></i> iOS
				</el-button>
			</el-popover>
			<el-popover placement="bottom" trigger="hover"><img src='../../assets/img/home/code_android.png'>
				<el-button slot="reference"><i class="iconfont icon-anzhuo"></i>Android</el-button>
			</el-popover>
		</div>
		<ul>
			<li v-for="item in list" @mouseover="update(item)" @mouseout="update(item)">
				<img :src="item.img" />
				<div>{{item.name}}</div>
				<small>{{item.desc}}</small>
			</li>
		</ul>
		<img src="../../assets/img/home/phone.png" />
	</div>
</template>
<script>
	export default {
		data() {
			return {
				"list": [{
						"name": "智能控制",
						"desc": "提供多款主流设备模版页面，可自定义控制任意设备",
						"img": require("@/assets/img/home/5_1.png"),
						"img_hover": require("@/assets/img/home/5_1_hover.png")
					},
					{
						"name": "场景控制",
						"desc": "自定义条件出发多设备控制命令转化成一键或自动化控制",
						"img": require("@/assets/img/home/5_2.png"),
						"img_hover": require("@/assets/img/home/5_2_hover.png")
					},
					{
						"name": "调试控制",
						"desc": "创建开发板设备，自定义开关控制或数据显示的控件",
						"img": require("@/assets/img/home/5_3.png"),
						"img_hover": require("@/assets/img/home/5_3_hover.png")
					},
				],
			}
		},
		computed: {},
		methods: {
			update: function(item) {
				var temp = item.img;
				item.img = item.img_hover;
				item.img_hover = temp;
			},
		},
		components: {},
		created() {}
	}
</script>
<style lang="less">
	@import url("../../assets/common.less");
	#page_5 {
		.page();
		background-image: linear-gradient(-90deg, #385f81 50%, #212930 100%);
		&>h1 {
			font-size: 30px;
			position: absolute;
			width: 100vw;
			top: 15vh;
			left: 10vw;
			color: #DDD;
			&>img {
				float: left;
				height: 5vw;
				padding-right: 15px;
			}
			&>div:nth-of-type(1) {
				font-size: 1.4vw;
				line-height: 1.4vw;
			}
			&>div:nth-of-type(2) {
				font-size: 2.5vw;
				line-height: 4vw;
			}
		}
		;
		&>.btn-group {
			position: absolute;
			top: 35vh;
			left: 10vw;
			color: #DDD;
			.el-button {
				background-color: rgba(0, 0, 0, 0);
				color: #DDDDDD;
				border-color: #DDDDDD;
				width: 200px;
				height: 40px;
				&:hover {
					background-color: @theme-color;
					border-color: @theme-color;
				}
				i {
					padding-right: 20px;
				}
			}
		}
		&>ul {
			position: absolute;
			top: 50vh;
			left: 10vw;
			width: 60vw;
			min-width: 400px;
			color: #DDD;
			li {
				height: 5vw;
				margin: 10px 10px 10px 0;
				vertical-align: middle;
				&>img {
					height: 100%;
					padding: 5px;
					padding-right: 15px;
					float: left;
				}
				&>div {
					font-size: 1.5vw;
					line-height: 3vw;
				}
				&>small {
					height: 20px;
					font-size: 1.2vw;
					line-height: 1.5vw;
				}
			}
		}
		&>img {
			position: absolute;
			right: 10vw;
			top: 20vh;
			@media (max-width: 1280px) {
				& {
					width: 30vw;
				}
			}
			@media (max-width: 768px) {
				& {
					top: 5vh;
					left: 0;
					right: 0;
					margin: 0 auto;
					width: auto;
					height: 25vh;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// page_5.vue?65132081